<template>
  <div v-if="user" class="bg-white shadow overflow-hidden sm:rounded-lg mb-5">
    <div class="px-4 py-3 sm:px-6">
      <h3 class="text-lg leading-6 font-medium text-gray-900">Utilisateur "{{ user.username }}"</h3>
    </div>
    <div class="border-t border-gray-200">
      <dl>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">ID</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{ user.id }}</dd>
        </div>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">Avatar</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
            <Avatar
              :image="avatar_face"
              shape="circle"
              class="p-1"
              :style="{ 'background-color': user.color }"
            />
          </dd>
        </div>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">Nom</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{ user.username }}</dd>
        </div>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">Email</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{ user.email }}</dd>
        </div>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">Date de création</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{ user.created_at }}</dd>
        </div>
        <div class="bg-lighter px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-sm font-medium text-gray-700">Date de modification</dt>
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{ user.updated_at }}</dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Avatar from "primevue/avatar/Avatar";

import avatar_face from "~/assets/img/avatars/face-1.svg";

export default {
  name: "UserDetails",
  components: {
    Avatar,
  },
  data: () => ({
    avatar_face: avatar_face,
  }),
  computed: {
    ...mapGetters("users", {
      user: "getActive",
    }),
  },
};
</script>

<style scoped></style>
